<div class="row files-row" *ngIf="!hiddenList && !branchedImages.tree">
  <div class="file" *ngFor="let x of images; let i = index" [draggable]="draggable" (dragstart)="onDrag($event)">
    <figure class="image__figure justify-content-between" (click)="openImageInModal(x,i)" [ngClass]="selection.includes(x.fileId) ? 'bgSelected' : ''">
      <div class="selected" *ngIf="selection.includes(x.fileId)"><i class="fas fa-check-circle fa-2x text-success stroker"></i></div>
      <div class="img-link" *ngIf="x.extension == '.pdf' || x.extension == '.blob'">
        <img [attr.id]="x.fileId" src="../../../assets/img/icons/pdfIcon.png" alt="pdf" class="img-responsive" title="{{ x.originalName }}" />
      </div>
      <div [attr.id]="x.fileId" class="img-link" *ngIf="x.extension == '.xls' || x.extension == '.xlsx'">
        <img src="../../../assets/img/icons/xlsxIcon.png" alt="excel" class="img-responsive" title="{{ x.originalName }}" />
      </div>
      <div class="img-link" *ngIf="x.extension == '.jpg' || x.extension == '.jpeg' || x.extension == '.png'">
        <img [attr.id]="x.fileId" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ x.fileId }}?userId={{currentUser}}" alt="image" class="img-responsive" title="{{ x.originalName }}" />
      </div>
      <div *ngIf="x.extension == '.msg'"><i class="far fa-envelope fa-4x"></i></div>
      <div class="img-link fakeImg" *ngIf="isOtherFileType(x.extension)">
        {{ x.extension | uppercase }}
      </div>
      <figcaption class="figure-caption text-center">{{ (x.originalName.length > 12)? (x.originalName | slice:0:12): (x.originalName) }}</figcaption>
    </figure>
  </div>
</div>

<div class="row" *ngIf="branchedImages.tree">
  <div class="col-3 branchView">
    <app-image-branch [data]="branchedImages.tree" [options]="data" [selectedFolder]="branchedImages.selectedFolder" (bubble)="branchedImages.childEvent($event)"></app-image-branch>
  </div>
  <div class="col-9">
    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-between pl-3 pr-3 mt-3">
        <div class="underlineFocused"><input class="highlightFolderName" type="text" autocomplete="off" [(ngModel)]="branchedImages.viewFolder.name" *ngIf="branchedImages.viewFolder.id != branchedImages.rootId" (change)="renameFolder()"/></div>
        <div class="d-flex">
          <button class="btn btn-sm btn-primary" (click)="addFolder()">{{ 'Standard.NewFolder' | translate }}</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 pl-3" *ngIf="branchedImages.viewFolder != null">
        <app-image-modal [id]="branchedImages.viewFolder.path" [images]="branchedImages.viewFolder.items" [options]="data" [draggable]="true" (deleteFile)="itemToDelete($event)" (bubble)="bubbleCatcher($event)"></app-image-modal>
      </div>
    </div>
  </div>
</div>

<button [attr.id]="'imageView' + modalId +'Activator'" hidden  data-toggle="modal" [attr.data-target]="'#imageView' + modalId"></button>

<div [attr.id]="'imageView' + modalId" modal class="modal fade" tabindex="-1" role="dialog" data-toggle="modal" aria-labelledby="modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="images != null && images != undefined && images.length != 0 && images[index] != undefined">
      <div class="modal-body text-center">
        <div class="close">
          <div (click)="closer()"><i class="actionButton fal fa-times"></i></div>
          <a href="https://jubloapi.azure-api.net/api/shared/attachments/{{ images[index].fileId }}?userId={{currentUser}}" target="_blank"><i class="actionButton fas fa-download"></i></a>
          <div (click)="rotate = rotate - 90" *ngIf="checkIfValidImage(images[index].extension)" ><i class="fas fa-undo actionButton rotators"></i></div>
          <div class="flipHorizontal" (click)="rotate = rotate + 90" *ngIf="checkIfValidImage(images[index].extension)" ><i class="fas fa-undo actionButton rotators"></i></div>
          <div *ngIf="!!data && data.canBeDeleted == true" (click)="itemToDelete(images[index].fileId); closer()"><i class="actionButton fas fa-trash-alt"></i></div>
        </div>
        <div class="imageHolder customScroll" style="width:80%; justify-content:center">
          <img [style.transform]="'rotate(' + rotate + 'deg)'" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ images[index].fileId }}?userId={{currentUser}}" alt="Alternate Text" *ngIf="checkIfValidImage(images[ index ].extension)" />
          <app-img-heic [fileId]="images[index].fileId" [style]="'max-height: 81vh;max-width: 100%;object-fit: contain;vertical-align: middle;color:white; font-size:2rem'" *ngIf="images[ index ].extension == '.heic'"></app-img-heic>
          <div *ngIf="images[index].extension == '.pdf' || images[index].extension == '.blob'">
            <pdf-viewer *ngIf="isOpen" [render-text]="true" [render-text-mode]="1" [src]="currentPdf"></pdf-viewer>
          </div>
          <div class="fakeImgMax" *ngIf="unsupportedFileType(images[ index ].extension)">
            <div class="mb-5">{{ images[ index ].extension }}</div>
            <div>{{ 'Images.ImageTypeNotSupported' | translate }}</div>
          </div>
          <div style="width:100%" *ngIf="officeFileType(images[ index ].extension)">
            <ngx-doc-viewer [url]="getURL(images[index].fileId)" viewer="office" style="width:100%;height:86vh;"></ngx-doc-viewer>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div *ngFor="let x of images; let i = index" class="cursor-pointer">
          <img [ngClass]="i == index ? 'viewing' : ''" class="thumb cursor" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ x.fileId }}?userId={{currentUser}}" (click)="index = i; rotate= 0" alt="Alternate Text" *ngIf="checkIfValidImage(x.extension)" />
          <img [ngClass]="i == index ? 'viewing' : ''" class="thumb cursor" src="../../../assets/img/icons/pdfIcon.png" (click)="currentPdf = null; index = i; currentPdf = getURL(images[i].fileId); isOpen = true; ; rotate= 0 " alt="Alternate Text" *ngIf="x.extension == '.pdf' || x.extension == '.blob'" />
          <div class="fakeImgMini" *ngIf="isOtherFileType(x.extension)" (click)="index = i; rotate= 0">{{ x.extension }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
